/*
 * Author: Dw
 * File Created: Thursday, 24-07-11 10:21 am
 * Last Modified: Tuesday, 25-03-25 08:08 pm, by Harper Yan
 */

export function pick<T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Pick<T, K> {
  const result = {} as Pick<T, K>;

  keys.forEach((key) => {
    if (key in obj) {
      result[key] = obj[key];
    }
  });

  return result;
}

export function omit<T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Omit<T, K> {
  const result = {} as T;

  (Object.keys(obj) as Array<keyof T>).forEach((key) => {
    if (!keys.includes(key as K)) {
      result[key] = obj[key];
    }
  });

  return result as Omit<T, K>;
}

export type TypeofResult =
  | 'string'
  | 'number'
  | 'boolean'
  | 'bigint'
  | 'symbol'
  | 'object'
  | 'array'
  | 'function'
  | 'date'
  | 'regexp'
  | 'set'
  | 'map'
  | 'null'
  | 'undefined';

export function _typeof(ele: any): TypeofResult {
  if (ele === null) return 'null';

  if (typeof ele !== 'object') {
    return typeof ele as TypeofResult;
  }

  const typeStr = Object.prototype.toString.call(ele);
  const rawType = typeStr.slice(8, typeStr.length - 1).toLowerCase();

  // 映射对象，确保返回值是 TypeofResult 中的一个
  const typeMap: Record<string, TypeofResult> = {
    array: 'array',
    date: 'date',
    regexp: 'regexp',
    set: 'set',
    map: 'map',
    object: 'object',
    function: 'function',
  };

  return typeMap[rawType] || 'object';
}
